import { createFileRoute } from '@tanstack/react-router';
import { createColumnHelper } from '@tanstack/react-table';
import api from '@/api';
import type { components } from '@/api/qraft/schema';
import { createTablePage } from '~/components/ui/createTablePage';
import { LIST_PAGE_SIZE } from '~/components/ui/Pagination';

type StudentInformation = components['schemas']['StudentInformation'];

const columnHelper = createColumnHelper<StudentInformation>();

const columns = [
  columnHelper.accessor('id', {
    header: 'ID',
  }),
  columnHelper.accessor((row) => row.display_name, {
    id: 'name',
    header: 'Name',
  }),
  columnHelper.accessor((row) => row.country, {
    id: 'country',
    header: 'Country',
  }),
  columnHelper.accessor((row) => row.language, {
    id: 'language',
    header: 'Language',
  }),
];

const StudentsList = createTablePage<
  StudentInformation,
  '/students/$studentId'
>({
  name: 'Students',
  searchable: true,
  searchPlaceholder: 'Search by name or email',
  useData: (page, search) => {
    const trimmed = search.trim();
    return api.getStudents.useQuery({
      query: {
        limit: LIST_PAGE_SIZE,
        offset: LIST_PAGE_SIZE * page,
        ...(trimmed ? { search: trimmed } : {}),
      },
    });
  },
  columns: columns,
  itemBaseUrl: '/students/$studentId',
  getParams: (row) => ({ studentId: String(row.id) }),
});

export const Route = createFileRoute('/_admin/students/')({
  component: StudentsList,
});
